import { RemoteParticipant, RemoteVideoStream } from '@azure/communication-calling';
import { combineReducers, Reducer } from 'redux';
import { devicesReducer, DevicesState } from '../reducers/devices';
import { streamsReducer, StreamsState } from './streams';
import { controlsReducer, ControlsState } from './controls';
import { SdkState, sdkReducer } from './sdk';
import { CallsState, callsReducer } from './calls';
import { CallTypes } from '../actions/calls';
import { ControlTypes } from '../actions/controls';
import { DeviceTypes } from '../actions/devices';
import { SdkTypes } from '../actions/sdk';
import { StreamTypes } from '../actions/streams';
import { ContosoState, ContosoReducer } from './ContosoClientReducers';
import { ConversationsState, ConversationsReducer } from './ConversationsReducers';
import { MessagesState, MessagesReducer } from './MessagesReducer';
import { ThreadState, ThreadReducer } from './ThreadReducers';
import { ThreadMembersState, ThreadMembersReducer } from './ThreadMembersReducers';
import { ContosoActionTypes } from '../actions/ContosoClientAction';
import { ConversationsActionTypes } from '../actions/ConversationsAction';
import { MessagesActionTypes } from '../actions/MessagesAction';
import { ThreadActionTypes } from '../actions/ThreadAction';
import { ThreadMembersActionTypes } from '../actions/ThreadMembersAction';

export interface ParticipantStream {
    user: RemoteParticipant;
    stream: RemoteVideoStream | undefined;
}

export interface State {
    calls: CallsState;
    devices: DevicesState;
    streams: StreamsState;
    controls: ControlsState;
    sdk: SdkState;
    chat: MessagesState;
    contosoClient: ContosoState;
    conversations: ConversationsState;
    thread: ThreadState;
    threadMembers: ThreadMembersState;
}

type AppTypes = CallTypes | ControlTypes | DeviceTypes | SdkTypes | StreamTypes | MessagesActionTypes
    | ContosoActionTypes
    | ConversationsActionTypes
    | ThreadMembersActionTypes
    | ThreadActionTypes;

export const reducer: Reducer<State, AppTypes> = combineReducers({
    calls: callsReducer,
    devices: devicesReducer,
    streams: streamsReducer,
    controls: controlsReducer,
    sdk: sdkReducer,
    chat: MessagesReducer,
    contosoClient: ContosoReducer,
    conversations: ConversationsReducer,
    thread: ThreadReducer ,
    threadMembers: ThreadMembersReducer
});